<template>
  <div @mouseleave="handleMouseLeave">
    <v-chart ref="curChart" v-if="!change && chartData.length > 0" :width="250" :height="200" :data="chartData" :scale="chart.scale" :padding="chart.padding" :onPlotLeave="handlePlotLeave">
      <v-tooltip :show-title="false" />
      <v-coord type="rect" direction="TL" />
      <v-point position="x*y" shape="cloudPoint" tooltip="value" />
    </v-chart>
    <a-empty v-if="chartData.length == 0" description="稍后呈现" />
  </div>
</template>

<script>
import { registerShape } from 'viser-vue';
const DataSet = require('@antv/data-set');
import _ from 'lodash';

registerShape('point', 'cloudPoint', {
  draw(cfg, container) {
    return container.addShape('text', {
      attrs: {
        fillOpacity: cfg.opacity,
        fontSize: cfg.origin._origin.size,
        rotate: cfg.origin._origin.rotate,
        text: cfg.origin._origin.text,
        textAlign: 'center',
        fill: cfg.color,
        textBaseline: 'Alphabetic',
        ...cfg.style,
        x: cfg.x,
        y: cfg.y,
      },
    });
  }
});

export default {
  name: 'OpinionChart',
  props: ['cData'],
  data() {
    return {
      change: false,
    }
  },
  computed: {
    chart() {
      return {
        scale: [
          { dataKey: 'x', nice: false },
          { dataKey: 'y', nice: false },
        ],
        padding: [10]
      }
    },
    chartData() {
      if (!_.isNil(this.cData)) {
        const oriData = Object.entries(this.cData || {}).map(([k, v]) => ({
          label: k,
          value: _.toNumber(v)
        }));
        if (oriData.length === 0) {
          return [];
        }
        const dv = new DataSet.View().source(oriData);
        const range = dv.range('value');
        const min = range[0];
        const max = range[1];
        dv.transform({
          type: 'tag-cloud',
          fields: ['label', 'value'],
          size: [250, 200],
          padding: 0,
          timeInterval: 5000, // max execute time
          rotate() {
            // let random = ~~(Math.random() * 4) % 4;
            // if (random == 2) {
            //   random = 0;
            // }
            // return random * 90; // 0, 90, 270
            return 0;
          },
          fontSize(d) {
            if (d.value) {
              return ((d.value - min) / (max - min)) * (40 - 12) + 12;
            }
            return 0;
          },
          font: 'Impact',
        });
        return dv.rows;
      } else {
        return [];
      }
    }
  },
  methods: {
    handleMouseLeave() {
      this.$refs.curChart?.chart?.chartInstance?.hideTooltip();
    },
    handlePlotLeave(ev, chart) {
      chart.hideTooltip();
    },
  }  
}
</script>

<style>

</style>